import React,{useState} from 'react'
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import {linkGoogleAnalyticsAccount} from "../../../../services/ApiService"
const GoogleAnalyticsAdAccountTable = (
    {
        customerAccounts,
        fetchAdsAccountStatus,
        setShowAdsAccountsModal,
    
    }
) => {
    const headers = [
        { label: "Sl.No", key: "sl.no" },
        { label: "Account Id", key: "id" },
        { label: "Account Name", key: "descriptiveName" },
        { label: "Region Code", key: "region_code" },
         { label: "Actions", key: "actions" },
      ];
      const [loading, setLoading] = useState({}); 
      const navigate=useNavigate()

       const handleLinkAccount=async (account,index)=>{
         setLoading((prev) => ({ ...prev, [index]: true })); // Set loading for the specific button
         try {
           const data = await linkGoogleAnalyticsAccount(account);
           if (data?.success) {
     
             setShowAdsAccountsModal(false)
             fetchAdsAccountStatus();
             toast.success("Account linked successfully");
           } else {
             toast.error("Something went wrong");
           }
         } catch (error) {
           toast.error("Something went wrong");
         } finally {
           setLoading((prev) => ({ ...prev, [index]: false })); // Stop loading
           navigate('/client/settings/integrations')
         }
       }





  return (
    <>
      <div className="card-lg  bg-light">
        <div className="table-responsive text-nowrap card-body py-0">
          <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 table-auto m-0">
            <thead>
              <tr className="fw-bold text-muted bg-light">
                {headers.map((header) => (
                  <th className={`min-w-100px ${header.label==='Actions'&&'text-end'}`} key={header.key}>
                   {header.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {customerAccounts.length === 0 ? (
                <tr>
                  <td
                    colSpan={headers.length}
                    className="text-center text-muted"
                  >
                    No data available
                  </td>
                </tr>
              ) : (
                customerAccounts?.map((account, index) => (
                  <tr className="text-muted" key={index}>
                    <td>{index + 1}</td>
                    <td>{account?.account_id || "---"}</td>
                    <td>{account?.display_name || "---"}</td>
                    <td>{account?.region_code || "---"}</td>
            
                    <td className="d-flex justify-content-end">
                      <button
                        className="btn btn-sm rounded-pill btn-primary   d-flex align-items-center  justify-content-center"
                        style={{width:"150px"}}
                        onClick={() => {
                            handleLinkAccount(account,index)
                        }}
                        disabled={loading[index]} // Disable button while loading
                      >
                        {loading[index] ? (
                          <>
                            <span >Please Wait...</span>
                          </>
                        ) : (
                          <span >
                            {account?.manager
                              ? "View client A/c"
                              : "Connect Account"}
                          </span>
                        )}
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

    </>
  )
}

export default GoogleAnalyticsAdAccountTable